module.exports = __webpack_public_path__ + "img/purple1.8f8bc08d.svg";